<div class="step-photo">
  <h2>Heeft u foto's?</h2>
  <div class="step-content-label">Het toevoegen van foto's helpt om uw melding zo goed mogelijk op te pakken. U kunt maximaal 6 foto’s toevoegen.</div>
  <br />
  <app-photo-manager></app-photo-manager>
</div>
